import { ChangeDetectionStrategy, Component, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
    selector: 'kb-tab',
    template: `<ng-template #tabContent><ng-content></ng-content></ng-template>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class TabComponent {
    @Input() title: string;
    @ViewChild('tabContent', { read: TemplateRef }) templateRef: TemplateRef<any>;
}
